module.exports = __webpack_public_path__ + "img/PrezencePrint.9c4c3672.png";